import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Observable, defer, from } from 'rxjs';
import { UI_TOOLS_TRANSLOCO_SCOPE } from '../ui-tools-transloco-scope';

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {
  constructor(private translocoService: TranslocoService) {}

  copyToClipboard(inputText: string): Observable<void> {
    return defer(() => from(navigator.clipboard.writeText(inputText)));
  }

  getClipboardCopiedText(): Observable<string> {
    return this.translocoService.selectTranslate('copyToClipboard.copied', {}, UI_TOOLS_TRANSLOCO_SCOPE);
  }

  getTooltipDelay(): number {
    return 2000;
  }
}
